class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
    this.onCartRefreshListener = this.onCartRefresh.bind(this);
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);
  }

  get requiresBodyAppended() {
    return false;
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      "cart:grouped-sections",
      this.getSectionToRenderListener
    );
    document.addEventListener("cart:refresh", this.onCartRefreshListener);
}

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      "cart:grouped-sections",
      this.getSectionToRenderListener
    );
    document.removeEventListener("cart:refresh", this.onCartRefreshListener);
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open && !Shopify.designMode) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);

      document.dispatchEvent(new CustomEvent("cart:opened"));
    }
  }

  async onCartRefresh(event) {
    const cartId = `CartDrawer-${this.sectionId}`;

    const cartElement = document.getElementById(cartId);
    if (!cartElement) return;

    try {
      const response = await fetch(
        `${FoxTheme.routes.root_url}?section_id=${this.sectionId}`
      );
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, "text/html");

      const newCartContent = parsedHTML.getElementById(cartId).innerHTML;
      cartElement.innerHTML = newCartContent;

      if (event.detail.open === true) {
        this.show();
      } else if (this.open) {
        document.dispatchEvent(new CustomEvent("cart:opened"));
      }
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  }

  handleAfterHide() {
    super.handleAfterHide();
    document.dispatchEvent(new CustomEvent("cart:closed"));
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      FoxTheme.utils.debounce(this.onChange.bind(this), 300)
    );
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );

    this.cartItemProducts = this.querySelectorAll(".cart-item__product");
    this.cartItemQuantitys = this.querySelectorAll(".cart-item__quantity");

    const loadTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const template = element.querySelector("template");
        const templateContent =
          template && document.importNode(template.content, true);
        const parent = element.querySelector(parentSelector);

        if (parent && template && !parent.querySelector(".template-content")) {
          const contentWrapper = document.createElement("div");
          contentWrapper.classList.add("template-content");
          contentWrapper.appendChild(templateContent);
          parent.appendChild(contentWrapper);
        }
      });
    };

    const removeTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const parent = element.querySelector(parentSelector);
        const templateContent = parent?.querySelector(".template-content");

        if (templateContent) {
          parent.removeChild(templateContent);
        }
      });
    };

    const handleTabletMatch = () => {
      loadTemplateContent(this.cartItemProducts, ".cart-item__product--info");
      removeTemplateContent(
        this.cartItemQuantitys,
        ".cart-item__quantity-wrapper"
      );
    };

    const handleTabletUnmatch = () => {
      removeTemplateContent(this.cartItemProducts, ".cart-item__product--info");
      loadTemplateContent(
        this.cartItemQuantitys,
        ".cart-item__quantity-wrapper"
      );
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;

    if (FoxTheme.config.mqlTablet) {
      handleTabletMatch();
    } else {
      handleTabletUnmatch();
    }

    mqlTablet.onchange = (event) => {
      if (event.matches) {
        handleTabletMatch();
      } else {
        FoxTheme.config.mqlTablet = false;
        handleTabletUnmatch();
      }
    };

    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target
    );
  }

  onCartError(errors, target) {
    if (target) {
      this.updateQuantity(
        target.getAttribute("data-index"),
        target.defaultValue,
        document.activeElement.getAttribute("name"),
        target
      );
    } else {
      window.location.href = FoxTheme.routes.cart_url;
    }
    alert(errors);
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionId = FoxTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(
      event.cart.sections[sectionId],
      "text/html"
    );

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(
      `#CartDrawerBody-${sectionId}`
    );
    const cartDrawerFooter = document.querySelector(
      `#CartDrawerFooter-${sectionId}`
    );
    const cartDrawerEmpty = document.querySelector(
      `#CartDrawerEmpty-${sectionId}`
    );
    if (cartDrawer) {
      const cartDrawerBodyUpdate = sectionToRender.querySelector(
        `#CartDrawerBody-${sectionId}`
      );
      const cartDrawerFooterUpdate = sectionToRender.querySelector(
        `#CartDrawerFooter-${sectionId}`
      );
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(
        `#CartDrawerEmpty-${sectionId}`
      );

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }

      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove("hidden");
        cartDrawerFooter.classList.remove("hidden");
        cartDrawerEmpty.classList.add("hidden");
      } else {
        cartDrawerBody.classList.add("hidden");
        cartDrawerFooter.classList.add("hidden");
        cartDrawerEmpty.classList.remove("hidden");
      }

      const drawerGoal = cartDrawer.querySelector("free-shipping-goal");
      const goalUpdate = sectionToRender.querySelector("free-shipping-goal");
      if (drawerGoal && goalUpdate) {
        drawerGoal.outerHTML = goalUpdate.outerHTML;
      } else if (drawerGoal) {
        const totalCents =
          event.cart.total_price ?? event.cart.items_subtotal_price ?? 0;
        if (typeof drawerGoal.updateShippingGoal === "function") {
          drawerGoal.updateShippingGoal(totalCents);
        } else if (typeof drawerGoal.updateProgress === "function") {
          drawerGoal.updateProgress(totalCents);
        }
        const goalCents =
          Number(drawerGoal.dataset.minimumAmount) *
          Number(window.Shopify?.currency?.rate || 1);
        const leftToSpendCents = Math.max(
          0,
          (goalCents || 0) - (Number(totalCents) || 0)
        );
        const leftEl = drawerGoal.querySelector("[data-left-to-spend]");
        if (leftEl) {
          if (typeof Shopify?.formatMoney === "function") {
            leftEl.textContent = Shopify.formatMoney(leftToSpendCents);
          } else if (FoxTheme?.Currency?.formatMoney) {
            leftEl.textContent = FoxTheme.Currency.formatMoney(
              leftToSpendCents,
              FoxTheme?.settings?.moneyFormat
            );
          }
        }
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(
        `#MainCart-${sectionId}`
      );
      if (updatedElement) {
        const currentBogosProgress = mainCart.querySelector(
          ".main-cart__bogos-progress"
        );
        mainCart.innerHTML = updatedElement.innerHTML;
        const updatedBogosProgress = mainCart.querySelector(
          ".main-cart__bogos-progress"
        );
        if (currentBogosProgress && updatedBogosProgress) {
          const updatedSavings =
            updatedBogosProgress.dataset.bogosCartSavings;
          if (updatedSavings) {
            currentBogosProgress.dataset.bogosCartSavings = updatedSavings;
          } else {
            delete currentBogosProgress.dataset.bogosCartSavings;
          }
          const updatedOriginalCents =
            updatedBogosProgress.dataset.bogosCartOriginalCents;
          if (updatedOriginalCents) {
            currentBogosProgress.dataset.bogosCartOriginalCents =
              updatedOriginalCents;
          } else {
            delete currentBogosProgress.dataset.bogosCartOriginalCents;
          }
          updatedBogosProgress.replaceWith(currentBogosProgress);
        }
        if (event.cart.item_count > 0) {
          mainCart.closest(".cart").classList.remove("is-empty");
        } else {
          mainCart.closest(".cart").classList.add("is-empty");
        }
      } else {
        mainCart.closest(".cart").classList.add("is-empty");
        mainCart.remove();
      }
    }

    const lineItem =
      document.getElementById(`CartItem-${event.line}`) ||
      document.getElementById(`CartDrawer-Item-${event.line}`);

    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      FoxTheme.a11y.trapFocus(
        mainCart || cartDrawer,
        lineItem.querySelector(`[name="${event.name}"]`)
      );
    } else if (event.cart.item_count === 0) {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector("a"))
        : FoxTheme.a11y.trapFocus(
            document.querySelector(".cart__empty"),
            document.querySelector("a")
          );
    } else {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(
            cartDrawer,
            cartDrawer.querySelector(".cart-item__title")
          )
        : FoxTheme.a11y.trapFocus(
            mainCart,
            mainCart.querySelector(".cart-item__title")
          );
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: {
          cart: event.cart,
        },
      })
    );
  }

  updateQuantity(line, quantity, name, target) {
    this.showLoader(line);
    document.body.classList.add("is-cart-quantity-updating");

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: parsedState,
          target,
          line,
          name,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setTimeout(() => {
          document.body.classList.remove("is-cart-quantity-updating");
        }, 5000);
      });
  }

  showLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add("btn--loading");
      });
    }
  }
}

customElements.define("cart-items", CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      document.body.classList.add("is-cart-quantity-updating");

      const cartItems = this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-item", CartRemoveItem, { extends: "a" });
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      FoxTheme.utils.debounce(this.onChange.bind(this), 300)
    );

    if (this.button && this.cartNoteDetailsSummary) {
      this.button.addEventListener("click", () => {
        this.cartNoteDetailsSummary.close();
      });
    }
  }

  get cartNoteDetailsSummary() {
    return this.closest('[is="accordion-details"]');
  }

  get button() {
    return this.querySelector('[type="button"]');
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    });
  }
}
customElements.define("cart-note", CartNote);

class CalculateShipping extends ModalComponent {
  constructor() {
    super();
    this.countryProvince = this.querySelector("country-province");
    this.isCountrySetup = false;
  }
  static get observedAttributes() {
    return [...super.observedAttributes, "data-show"];
  }
  show() {
    super.show();
    this.setAttribute("data-show", true);
  }

  hide() {
    super.hide();
    this.setAttribute("data-show", false);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (
      name === "data-show" &&
      newValue === "true" &&
      !this.isCountrySetup &&
      this.countryProvince
    ) {
      const template = this.countryProvince.querySelector("template");
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
}
customElements.define("calculate-shipping", CalculateShipping);
class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener(
      "change",
      this.handleCountryChange.bind(this)
    );
    if (this.template && this.template === "cart") {
      this.init();
    }
  }

  init() {
    if (this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex(
          (option) => option.textContent === this.dataset.country
        )
      );
      this.countryElement.dispatchEvent(new Event("change"));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option =
        this.countryElement.options[this.countryElement.selectedIndex],
      provinces = JSON.parse(option.dataset.provinces);

    this.provinceElement.closest(".form-field").hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = "";

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(
        new Option(data[1], data[0], selected, selected)
      );
    });
  }
}
customElements.define("country-province", CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener(
      "click",
      this.handleFormSubmit.bind(this)
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add("btn--loading");

    const body = JSON.stringify({
      shipping_address: { zip, country, province },
    });
    let sectionUrl = `${FoxTheme.routes.cart_url}/shipping_rates.json`;

    sectionUrl = sectionUrl.replace("//", "/");

    fetch(sectionUrl, {
      ...FoxTheme.utils.fetchConfig("javascript"),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove("btn--loading");
      });
  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error blocks-radius grid gap-2">
        <p class="font-body-bolder m-0">${
          FoxTheme.shippingCalculatorStrings.error
        }</p>
        <ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join(
          ""
        )}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(
      ({ presentment_name, currency, price }) => {
        return `<li style="list-style: none;"><span style="margin-right: 4px;">✦</span>${presentment_name}: ${currency} ${price}</li>`;
      }
    );
    this.resultsElement.innerHTML = `
      <div class="alert blocks-radius alert--${
        shippingRates.length === 0 ? "error" : "success"
      } grid gap-2 leading-tight">
        <p class="font-body-bolder m-0">${
          shippingRates.length === 0
            ? FoxTheme.shippingCalculatorStrings.notFound
            : shippingRates.length === 1
            ? FoxTheme.shippingCalculatorStrings.oneResult
            : FoxTheme.shippingCalculatorStrings.multipleResults
        }</p>
        ${
          shippingRatesList === ""
            ? ""
            : `<ul class="grid gap-1 text-sm" role="list">${shippingRatesList.join(
                ""
              )}</ul>`
        }
      </div>
    `;
  }
}
customElements.define("shipping-calculator", ShippingCalculator, {
  extends: "form",
});

class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
    this.isLoading = false;

    this.classes = {
      grid: "f-grid",
      swiper: "swiper",
      swiperWrapper: "swiper-wrapper",
      loading: "is-loading",
    };

    // Handle Safari separately
    const isSafari =
      navigator.userAgent.includes("Safari") &&
      !navigator.userAgent.includes("Chrome");
    if (isSafari) {
      this.init();
    } else {
      FoxTheme.Motion.inView(this, this.init.bind(this), {
        margin: "600px 0px 600px 0px",
      });
    }
  }

  disconnectedCallback() {
    // Cleanup
    this.destroyCarousel();
    const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
    mql.removeEventListener("change", this.handleCarousel.bind(this));
  }

  init() {
    if (this.isLoading || !this.dataset.url) return;

    this.isLoading = true;
    this.classList.add(this.classes.loading);

    fetch(this.dataset.url)
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.text();
      })
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector(".shopify-section");

        if (!sectionInnerHTML) return;

        const recommendations = sectionInnerHTML.querySelector(
          "cart-drawer-products-recommendation"
        );
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
          mql.addEventListener("change", this.handleCarousel.bind(this));
          this.handleCarousel();
          this.dispatchEvent(new CustomEvent("recommendations:loaded"));
        } else {
          this.closest(".shopify-section")?.remove();
        }
      })
      .catch((error) => {
        console.error("Error loading recommendations:", error);
        this.classList.add("has-error");
      })
      .finally(() => {
        this.isLoading = false;
        this.classList.remove(this.classes.loading);
      });
  }

  initCarousel() {
    if (!this.wrapper?.innerHTML.trim().length) {
      this.classList.add("hidden");
      return;
    }

    try {
      this.container.classList.add(this.classes.swiper);
      this.wrapper.classList.remove(this.classes.grid);
      this.wrapper.classList.add(this.classes.swiperWrapper);

      this.carousel = new FoxTheme.Carousel(this.slideContainer, {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: this.sliderNext,
          prevEl: this.sliderPrev,
        },
      });

      if (this.carousel) {
        this.carousel.init();
        this.calcNavButtonsPosition();
      }
    } catch (error) {
      console.error("Error initializing carousel:", error);
      this.destroyCarousel();
    }
  }

  handleCarousel() {
    if (FoxTheme.config.mqlMobile) {
      this.destroyCarousel();
    } else {
      this.initCarousel();
    }
  }

  destroyCarousel() {
    if (!this.wrapper?.innerHTML.trim().length) {
      this.classList.add("hidden");
      return;
    }
    this.container?.classList.remove(this.classes.swiper);
    this.wrapper?.classList.remove(this.classes.swiperWrapper);
    this.wrapper?.classList.add(this.classes.grid);

    // Only try to destroy if carousel exists and is an object
    if (
      this.carousel &&
      typeof this.carousel === "object" &&
      this.carousel.slider
    ) {
      this.carousel.slider.destroy();
      this.carousel = null;
    }
  }

  calcNavButtonsPosition() {
    if (!this.dataset.calcButtonPosition === "true") return;
    const firstMedia = this.querySelector(".product-card__image-wrapper");
    if (firstMedia && firstMedia.clientHeight > 0) {
      this.style.setProperty(
        "--swiper-navigation-top-offset",
        parseInt(firstMedia.clientHeight) / 2 + "px"
      );
    }
  }

  get slideContainer() {
    return this.querySelector(".swiper");
  }

  get sliderPagination() {
    return this.querySelector(".swiper-pagination");
  }

  get sliderNext() {
    return this.querySelector(".swiper-button-next");
  }

  get sliderPrev() {
    return this.querySelector(".swiper-button-prev");
  }

  get container() {
    return this.querySelector(
      ".cart-drawer-products-recommendation__container"
    );
  }

  get wrapper() {
    return this.querySelector(".cart-drawer-products-recommendation__wrapper");
  }
}

customElements.define(
  "cart-drawer-products-recommendation",
  CartDrawerProductsRecommendation
);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener(
      "cart:grouped-sections",
      this.getSectionToRender.bind(this)
    );
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }
}
customElements.define("main-cart", MainCart);

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      leftToSpend: "[data-left-to-spend]",
      progressBar: "progress-bar",
      progressFill: ".free-shipping-goal__default .free-shipping-goal__fill",
    };
    this.money_format = window.FoxTheme?.settings?.moneyFormat;
    this.progress = this.querySelector(this.selectors.progressBar);
    this.progressFill = this.querySelector(this.selectors.progressFill);
    this.leftToSpendEl = this.querySelector(this.selectors.leftToSpend);
    this.goalCents =
      Number(this.dataset.minimumAmount) *
      Number(window.Shopify?.currency?.rate || 1);
  }

  connectedCallback() {
    const initialTotal =
      Number(this.dataset.cartTotal) ?? 0;
    this.updateShippingGoal(initialTotal);
    this.cartUpdatedHandler = (event) => {
      const totalCents =
        event.detail?.cart?.items_subtotal_price ??
        event.detail?.cart?.total_price ??
        0;
      this.updateShippingGoal(totalCents);
    };
    document.addEventListener("cart:updated", this.cartUpdatedHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("cart:updated", this.cartUpdatedHandler);
  }

  updateShippingGoal(totalCents) {
    const amount = Number(totalCents) || 0;
    if (amount > 0) {
      this.classList.remove("hidden");
    } else {
      this.classList.add("hidden");
    }

    const goalCents = this.goalCents || 1;
    const percent =
      goalCents > 0 ? Math.min((amount / goalCents) * 100, 100) : 0;
    const leftToSpendCents = Math.max(goalCents - amount, 0);

    if (this.progress) {
      this.progress.style.setProperty("--percent", `${percent}%`);
      this.progress.dataset.value = amount / 100;
      this.progress.dataset.max = goalCents / 100;
    }
    if (this.progressFill) {
      this.progressFill.style.width = `${percent}%`;
    }

    const leftToSpendEl =
      this.leftToSpendEl ?? this.querySelector(this.selectors.leftToSpend);
    if (leftToSpendEl) {
      let formatted = "";
      try {
        if (FoxTheme?.Currency?.formatMoney) {
          formatted = FoxTheme.Currency.formatMoney(
            leftToSpendCents,
            this.money_format
          );
        }
      } catch (_) {}
      if (!formatted && typeof Shopify?.formatMoney === "function") {
        formatted = Shopify.formatMoney(leftToSpendCents);
      }
      if (formatted !== "") {
        leftToSpendEl.textContent = formatted;
      }
    }

    if (amount >= goalCents) {
      this.classList.add("free-shipping-goal--done");
    } else {
      this.classList.remove("free-shipping-goal--done");
    }
  }
}
if (!customElements.get("free-shipping-goal")) {
  customElements.define("free-shipping-goal", FreeShippingGoal);
}

window.FoxKitAddToCart = async (payload) => {
  if (!payload?.properties?.["_FoxKit offer"]) return;

  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson["sections"] = payload["sections"];
  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
    cart: cartJson,
  });

  document.dispatchEvent(
    new CustomEvent("product-ajax:added", {
      detail: {
        product: payload,
      },
    })
  );
};
